import * as React from 'react';
import { Link } from 'react-router-dom';
import Page from '../components/Page';
import InvitationList from '../components/InvitationList';
import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import { classes } from '../components/Button';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequest, getHeaders } from '../api/client';

const invitations = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/invitations',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

export default function Invitations() {
  const context = React.useContext(ProfileContext);
  const state = invitations(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page title="Invitations" subtitle="Manage the invitations">
      {state.error && <ErrorFlash error={state.error} />}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={{
            pathname: '/invitations/new',
          }}
          className={`${classes} dib ml-auto mr-auto`}
        >
          Create new
        </Link>
      </div>
      <InvitationList invitations={state.data || []} />
    </Page>
  );
}
